// /src/renderer/shared/utils/mouseTracker.ts
export interface MouseClick {
  x: number;
  y: number;
  button: number; // 0: 왼쪽, 1: 가운데, 2: 오른쪽
}

// 전역에서 최신 클릭 정보를 저장합니다.
export let lastMouseClick: MouseClick = { x: 0, y: 0, button: 0 };

window.addEventListener('mousedown', (event: MouseEvent) => {
  lastMouseClick = {
    x: event.clientX,
    y: event.clientY,
    button: event.button, // event.button은 0, 1, 2 값을 가짐
  };
});
